export enum BreakRules {
  WINNER = 'WINNER',

  ALTERNATE = 'ALTERNATE',

  ALTERNATE_TWO_BREAK = 'ALTERNATE_TWO_BREAK',

  THREESOME = 'THREESOME',
}
